import { api } from "../Configurations/axios";
import { PersonaFinepModel } from "../Models/PersonaFinepModel";

const GetAllPersonaFinep = async (id: string) => {
    try {
        var result = await api.get(`/PersonaFINEP/GetAllByRegister/${id}`);
        var response = result.data;
        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetPersonaFinep = async (id: string): Promise<PersonaFinepModel> => {
    try {
        var result = await api.get(`/PersonaFINEP/GetById/${id}`);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutPersonaFinep = async (person: PersonaFinepModel): Promise<void> => {
    try {
        var result = await api.put(`/PersonaFINEP/UpdatePersonaFINEP`, person);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PostPersonaFinep = async (person: PersonaFinepModel): Promise<void> => {
    try {
        var result = await api.post(`/PersonaFINEP/CreatePersonaFINEP`, person);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}


const DeletePersonaFinep = async (id: string): Promise<void> => {
    try {
        var result = await api.delete(`/PersonaFINEP/DeleteById/${id}`);
        var response = result.data;
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetPersonaFinep,
    GetAllPersonaFinep,
    PutPersonaFinep,
    PostPersonaFinep,
    DeletePersonaFinep
}